import { DetailPage } from "@/archetypes/DetailPage";
export function ReferenceDetailPage() {
  return (
    <DetailPage
      title="Reference detail"
      tabs={[
        { id: "overview", label: "Overview", content: <p>Overview body</p> },
        { id: "history", label: "History", content: <p>History body</p> },
      ]}
    />
  );
}
